import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import '../../styles/layout/bottom-navigation.scss';

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const navigationItems = [
    { 
      name: 'Home', 
      path: '/home', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      )
    },
    { 
      name: 'History', 
      path: '/history', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
      requiresAuth: true 
    },
    { 
      name: 'Support', 
      path: '/support', 
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      )
    },
  ].filter(item => !item.requiresAuth || isAuthenticated);

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const handleNavigationClick = (path: string) => {
    // Check if the path requires authentication (History only)
    const requiresAuth = path === '/history';
    
    if (requiresAuth && !isAuthenticated) {
      // Redirect to login page if not authenticated
      navigate('/login');
    } else {
      // Navigate normally if authenticated or path doesn't require auth
      navigate(path);
    }
  };

  return (
    <nav className="bottom-navigation">
      {navigationItems.map((item) => (
        <button
          key={item.path}
          className={`bottom-nav-item ${isActive(item.path) ? 'active' : ''}`}
          onClick={() => handleNavigationClick(item.path)}
          aria-label={item.name}
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span className="bottom-nav-label">{item.name}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNavigation;



